// 220px static brand logo (PNG, never animated or recolored). Scales up on desktop.
import React from "react";

export default function MeyecamLogo({ size = 220, className = "" }) {
  return (
    <div
      className={`flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
      data-testid="meyecam-logo"
    >
      <img
        src="/meyecam-logo.png"
        alt="mEYEcam"
        style={{ width: "100%", height: "100%", objectFit: "contain" }}
        draggable={false}
      />
    </div>
  );
}
